<div *ngIf="showConsentMessage" class="cookie-consent-container text-light p-3">
    <p class="mb-3">We use cookies to enhance your experience. By continuing to visit this site you agree to our use
        of cookies. More information can be found in our privacy policy.</p>
    <div class="d-flex justify-content-center">
        <button class="btn btn-success me-2" (click)="acceptConsent()">Accept</button>
        <button class="btn btn-danger" (click)="declineConsent()">Decline</button>
    </div>
</div>